/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2024-01-01",
    versionChannel: "nightly",
    buildDate: "2024-01-01T00:16:22.173Z",
    commitHash: "eac68a0647f78cb3dedc5c0a2d2899b29c7a9965",
};
